// src/pages/programManagerDashboard/ReportsPage.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Sidebar from "../../components/MasterSideBar";
import menuItems from "../../menuitems/menuItems.js";
import Topbar from "../../components/TopbarNav";
import ReportsDashboard from "../../components/ReportsDashboard";
import { getOverview, getTracking } from "../../api/reportApi";

export default function ReportsPage() {
  const [overview, setOverview] = useState(null);
  const [tracking, setTracking] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();


   const handleLogout = () => {
    localStorage.removeItem("token");
    // clear other auth state if any
    navigate("/login");
  };


  useEffect(() => {
    const fetchReports = async () => {
      try {
        const overviewData = await getOverview();
        const trackingData = await getTracking();
        setOverview(overviewData);
        setTracking(trackingData);
      } catch (error) {
        console.error("Error fetching reports:", error);
        // Dummy data if API fails
        setOverview({
          submitted: 12,
          pending: 5,
          evaluated: 8,
          notEvaluated: 4,
          completed: 8,
          delayed: 2
        });
        setTracking([
          { date: "2025-08-01", tasks: 5 },
          { date: "2025-08-02", tasks: 8 },
          { date: "2025-08-03", tasks: 6 },
          { date: "2025-08-04", tasks: 10 },
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchReports();
  }, []);

  if (loading) {
    return <p className="p-6">Loading reports...</p>;
  }

  return (
    <div className="flex min-h-screen bg-gray-50">
      <aside className="w-64 bg-white shadow-md">
        <Sidebar menuItems={menuItems} onLogout={handleLogout} />
      </aside>

      <div className="flex-1 flex flex-col">
        <header className="bg-white shadow p-4">
          <Topbar />
        </header>

        <main className="flex-1 p-6 overflow-auto">
          <h1 className="text-3xl font-bold mb-6">Reports Dashboard</h1>
          <ReportsDashboard overview={overview} tracking={tracking} />
        </main>
      </div>
    </div>
  );
}

